module.exports = __webpack_public_path__ + "static/media/441878666_1597868727721484_9216652487622124461_n.1db7ab54.jpg";